///foodpreorderevent/list
export const FOOD_PREORDER_EVENT_LIST = "FOOD_PREORDER_EVENT_LIST";
export const FOOD_PREORDER_EVENT_LIST_SUCCESS =
  "FOOD_PREORDER_EVENT_LIST_SUCCESS";
export const FOOD_PREORDER_EVENT_LIST_FAIL = "FOOD_PREORDER_EVENT_LIST_FAIL";

///foodpreorderevent/search
export const FOOD_PREORDER_EVENT_SEARCH = "FOOD_PREORDER_EVENT_SEARCH";
export const FOOD_PREORDER_EVENT_SEARCH_SUCCESS =
  "FOOD_PREORDER_EVENT_SEARCH_SUCCESS";
export const FOOD_PREORDER_EVENT_SEARCH_FAIL =
  "FOOD_PREORDER_EVENT_SEARCH_FAIL";

///foodpreorderevent/data
export const FOOD_PREORDER_EVENT_DATA = "FOOD_PREORDER_EVENT_DATA";
export const FOOD_PREORDER_EVENT_DATA_SUCCESS =
  "FOOD_PREORDER_EVENT_DATA_SUCCESS";
export const FOOD_PREORDER_EVENT_DATA_FAIL = "FOOD_PREORDER_EVENT_DATA_FAIL";

///foodpreorderevent/create
export const FOOD_PREORDER_EVENT_CREATE = "FOOD_PREORDER_EVENT_CREATE";
export const FOOD_PREORDER_EVENT_CREATE_SUCCESS =
  "FOOD_PREORDER_EVENT_CREATE_SUCCESS";
export const FOOD_PREORDER_EVENT_CREATE_FAIL =
  "FOOD_PREORDER_EVENT_CREATE_FAIL";

///foodpreorderevent/update
export const FOOD_PREORDER_EVENT_UPDATE = "FOOD_PREORDER_EVENT_UPDATE";
export const FOOD_PREORDER_EVENT_UPDATE_SUCCESS =
  "FOOD_PREORDER_EVENT_UPDATE_SUCCESS";
export const FOOD_PREORDER_EVENT_UPDATE_FAIL =
  "FOOD_PREORDER_EVENT_UPDATE_FAIL";

///foodpreorderevent/delete
export const FOOD_PREORDER_EVENT_DELETE = "FOOD_PREORDER_EVENT_DELETE";
export const FOOD_PREORDER_EVENT_DELETE_SUCCESS =
  "FOOD_PREORDER_EVENT_DELETE_SUCCESS";
export const FOOD_PREORDER_EVENT_DELETE_FAIL =
  "FOOD_PREORDER_EVENT_DELETE_FAIL";

///foodpreordereventguest/list
export const FOOD_PREORDER_EVENT_GUEST_LIST = "FOOD_PREORDER_EVENT_GUEST_LIST";
export const FOOD_PREORDER_EVENT_GUEST_LIST_SUCCESS =
  "FOOD_PREORDER_EVENT_GUEST_LIST_SUCCESS";
export const FOOD_PREORDER_EVENT_GUEST_LIST_FAIL =
  "FOOD_PREORDER_EVENT_GUEST_LIST_FAIL";

///foodpreordereventguest/search
export const FOOD_PREORDER_EVENT_GUEST_SEARCH =
  "FOOD_PREORDER_EVENT_GUEST_SEARCH";
export const FOOD_PREORDER_EVENT_GUEST_SEARCH_SUCCESS =
  "FOOD_PREORDER_EVENT_GUEST_SEARCH_SUCCESS";
export const FOOD_PREORDER_EVENT_GUEST_SEARCH_FAIL =
  "FOOD_PREORDER_EVENT_GUEST_SEARCH_FAIL";

///foodpreordereventguest/data/
export const FOOD_PREORDER_EVENT_GUEST_DATA = "FOOD_PREORDER_EVENT_GUEST_DATA";
export const FOOD_PREORDER_EVENT_GUEST_DATA_SUCCESS =
  "FOOD_PREORDER_EVENT_GUEST_DATA_SUCCESS";
export const FOOD_PREORDER_EVENT_GUEST_DATA_FAIL =
  "FOOD_PREORDER_EVENT_GUEST_DATA_FAIL";

///foodpreordereventguest/invite
export const FOOD_PREORDER_EVENT_GUEST_INVITE =
  "FOOD_PREORDER_EVENT_GUEST_INVITE";
export const FOOD_PREORDER_EVENT_GUEST_INVITE_SUCCESS =
  "FOOD_PREORDER_EVENT_GUEST_INVITE_SUCCESS";
export const FOOD_PREORDER_EVENT_GUEST_INVITE_FAIL =
  "FOOD_PREORDER_EVENT_GUEST_INVITE_FAIL";

///foodpreordereventguest/delete
export const FOOD_PREORDER_EVENT_GUEST_DELETE =
  "FOOD_PREORDER_EVENT_GUEST_DELETE";
export const FOOD_PREORDER_EVENT_GUEST_DELETE_SUCCESS =
  "FOOD_PREORDER_EVENT_GUEST_DELETE_SUCCESS";
export const FOOD_PREORDER_EVENT_GUEST_DELETE_FAIL =
  "FOOD_PREORDER_EVENT_GUEST_DELETE_FAIL";

// Food menu status
///foodmenustatus/list
export const FOOD_MENU_STATUS_LIST = "FOOD_MENU_STATUS_LIST";
export const FOOD_MENU_STATUS_LIST_SUCCESS = "FOOD_MENU_STATUS_LIST_SUCCESS";
export const FOOD_MENU_STATUS_LIST_FAIL = "FOOD_MENU_STATUS_LIST_FAIL";

///foodmenustatus/data
export const FOOD_MENU_STATUS_DATA = "FOOD_MENU_STATUS_DATA";
export const FOOD_MENU_STATUS_DATA_SUCCESS = "FOOD_MENU_STATUS_DATA_SUCCESS";
export const FOOD_MENU_STATUS_DATA_FAIL = "FOOD_MENU_STATUS_DATA_FAIL";

///foodmenustatus/create
export const FOOD_MENU_STATUS_CREATE = "FOOD_MENU_STATUS_CREATE";
export const FOOD_MENU_STATUS_CREATE_SUCCESS =
  "FOOD_MENU_STATUS_CREATE_SUCCESS";
export const FOOD_MENU_STATUS_CREATE_FAIL = "FOOD_MENU_STATUS_CREATE_FAIL";

///foodmenustatus/update
export const FOOD_MENU_STATUS_UPDATE = "FOOD_MENU_STATUS_UPDATE";
export const FOOD_MENU_STATUS_UPDATE_SUCCESS =
  "FOOD_MENU_STATUS_UPDATE_SUCCESS";
export const FOOD_MENU_STATUS_UPDATE_FAIL = "FOOD_MENU_STATUS_UPDATE_FAIL";

///foodmenustatus/delete
export const FOOD_MENU_STATUS_DELETE = "FOOD_MENU_STATUS_DELETE";
export const FOOD_MENU_STATUS_DELETE_SUCCESS =
  "FOOD_MENU_STATUS_DELETE_SUCCESS";
export const FOOD_MENU_STATUS_DELETE_FAIL = "FOOD_MENU_STATUS_DELETE_FAIL";

// food menu list
//foodmenu/list
export const FOOD_MENU_LIST = "FOOD_MENU_LIST";
export const FOOD_MENU_LIST_SUCCESS = "FOOD_MENU_LIST_SUCCESS";
export const FOOD_MENU_LIST_FAIL = "FOOD_MENU_LIST_FAIL";

///foodmenu/data
export const FOOD_MENU_DATA = "FOOD_MENU_DATA";
export const FOOD_MENU_DATA_SUCCESS = "FOOD_MENU_DATA_SUCCESS";
export const FOOD_MENU_DATA_FAIL = "FOOD_MENU_DATA_FAIL";

///foodmenu/create
export const FOOD_MENU_CREATE = "FOOD_MENU_CREATE";
export const FOOD_MENU_CREATE_SUCCESS = "FOOD_MENU_CREATE_SUCCESS";
export const FOOD_MENU_CREATE_FAIL = "FOOD_MENU_CREATE_FAIL";

///foodmenu/update
export const FOOD_MENU_UPDATE = "FOOD_MENU_UPDATE";
export const FOOD_MENU_UPDATE_SUCCESS = "FOOD_MENU_UPDATE_SUCCESS";
export const FOOD_MENU_UPDATE_FAIL = "FOOD_MENU_UPDATE_FAIL";

///foodmenu/delete
export const FOOD_MENU_DELETE = "FOOD_MENU_DELETE";
export const FOOD_MENU_DELETE_SUCCESS = "FOOD_MENU_DELETE_SUCCESS";
export const FOOD_MENU_DELETE_FAIL = "FOOD_MENU_DELETE_FAIL";

///foodmenuitem/list
export const FOOD_MENU_ITEM_LIST = "FOOD_MENU_ITEM_LIST";
export const FOOD_MENU_ITEM_LIST_SUCCESS = "FOOD_MENU_ITEM_LIST_SUCCESS";
export const FOOD_MENU_ITEM_LIST_FAIL = "FOOD_MENU_ITEM_LIST_FAIL";

///foodmenuitem/data
export const FOOD_MENU_ITEM_DATA = "FOOD_MENU_ITEM_DATA";
export const FOOD_MENU_ITEM_DATA_SUCCESS = "FOOD_MENU_ITEM_DATA_SUCCESS";
export const FOOD_MENU_ITEM_DATA_FAIL = "FOOD_MENU_ITEM_DATA_FAIL";

///foodmenuitem/create
export const FOOD_MENU_ITEM_CREATE = "FOOD_MENU_ITEM_CREATE";
export const FOOD_MENU_ITEM_CREATE_SUCCESS = "FOOD_MENU_ITEM_CREATE_SUCCESS";
export const FOOD_MENU_ITEM_CREATE_FAIL = "FOOD_MENU_ITEM_CREATE_FAIL";

///foodmenuitem/update
export const FOOD_MENU_ITEM_UPDATE = "FOOD_MENU_ITEM_UPDATE";
export const FOOD_MENU_ITEM_UPDATE_SUCCESS = "FOOD_MENU_ITEM_UPDATE_SUCCESS";
export const FOOD_MENU_ITEM_UPDATE_FAIL = "FOOD_MENU_ITEM_UPDATE_FAIL";

///foodmenuitem/delete
export const FOOD_MENU_ITEM_DELETE = "FOOD_MENU_ITEM_DELETE";
export const FOOD_MENU_ITEM_DELETE_SUCCESS = "FOOD_MENU_ITEM_DELETE_SUCCESS";
export const FOOD_MENU_ITEM_DELETE_FAIL = "FOOD_MENU_ITEM_DELETE_FAIL";

///foodpreordereventstatus/list
export const FOOD_PREORDER_EVENT_STATUS_LIST =
  "FOOD_PREORDER_EVENT_STATUS_LIST";
export const FOOD_PREORDER_EVENT_STATUS_LIST_SUCCESS =
  "FOOD_PREORDER_EVENT_STATUS_LIST_SUCCESS";
export const FOOD_PREORDER_EVENT_STATUS_LIST_FAIL =
  "FOOD_PREORDER_EVENT_STATUS_LIST_FAIL";

///foodpreordereventstatus/data
export const FOOD_PREORDER_EVENT_STATUS_DATA =
  "FOOD_PREORDER_EVENT_STATUS_DATA";
export const FOOD_PREORDER_EVENT_STATUS_DATA_SUCCESS =
  "FOOD_PREORDER_EVENT_STATUS_DATA_SUCCESS";
export const FOOD_PREORDER_EVENT_STATUS_DATA_FAIL =
  "FOOD_PREORDER_EVENT_STATUS_DATA_FAIL";

///foodpreordereventstatus/create
export const FOOD_PREORDER_EVENT_STATUS_CREATE =
  "FOOD_PREORDER_EVENT_STATUS_CREATE";
export const FOOD_PREORDER_EVENT_STATUS_CREATE_SUCCESS =
  "FOOD_PREORDER_EVENT_STATUS_CREATE_SUCCESS";
export const FOOD_PREORDER_EVENT_STATUS_CREATE_FAIL =
  "FOOD_PREORDER_EVENT_STATUS_CREATE_FAIL";

///foodpreordereventstatus/update
export const FOOD_PREORDER_EVENT_STATUS_UPDATE =
  "FOOD_PREORDER_EVENT_STATUS_UPDATE";

export const FOOD_PREORDER_EVENT_STATUS_UPDATE_SUCCESS =
  "FOOD_PREORDER_EVENT_STATUS_UPDATE_SUCCESS";
export const FOOD_PREORDER_EVENT_STATUS_UPDATE_FAIL =
  "FOOD_PREORDER_EVENT_STATUS_UPDATE_FAIL";

///foodpreordereventstatus/delete
export const FOOD_PREORDER_EVENT_STATUS_DELETE =
  "FOOD_PREORDER_EVENT_STATUS_DELETE";
export const FOOD_PREORDER_EVENT_STATUS_DELETE_SUCCESS =
  "FOOD_PREORDER_EVENT_STATUS_DELETE_SUCCESS";
export const FOOD_PREORDER_EVENT_STATUS_DELETE_FAIL =
  "FOOD_PREORDER_EVENT_STATUS_DELETE_FAIL";

///foodmenutype/list
export const FOOD_MENU_TYPE_LIST = "FOOD_MENU_TYPE_LIST";
export const FOOD_MENU_TYPE_LIST_SUCCESS = "FOOD_MENU_TYPE_LIST_SUCCESS";
export const FOOD_MENU_TYPE_LIST_FAIL = "FOOD_MENU_TYPE_LIST_FAIL";

///foodmenutype/data
export const FOOD_MENU_TYPE_DATA = "FOOD_MENU_TYPE_DATA";
export const FOOD_MENU_TYPE_DATA_SUCCESS = "FOOD_MENU_TYPE_DATA_SUCCESS";
export const FOOD_MENU_TYPE_DATA_FAIL = "FOOD_MENU_TYPE_DATA_FAIL";

///foodmenutype/create
export const FOOD_MENU_TYPE_CREATE = "FOOD_MENU_TYPE_CREATE";
export const FOOD_MENU_TYPE_CREATE_SUCCESS = "FOOD_MENU_TYPE_CREATE_SUCCESS";
export const FOOD_MENU_TYPE_CREATE_FAIL = "FOOD_MENU_TYPE_CREATE_FAIL";

///foodmenutype/update
export const FOOD_MENU_TYPE_UPDATE = "FOOD_MENU_TYPE_UPDATE";
export const FOOD_MENU_TYPE_UPDATE_SUCCESS = "FOOD_MENU_TYPE_UPDATE_SUCCESS";
export const FOOD_MENU_TYPE_UPDATE_FAIL = "FOOD_MENU_TYPE_UPDATE_FAIL";

///foodmenutype/delete
export const FOOD_MENU_TYPE_DELETE = "FOOD_MENU_TYPE_DELETE";
export const FOOD_MENU_TYPE_DELETE_SUCCESS = "FOOD_MENU_TYPE_DELETE_SUCCESS";
export const FOOD_MENU_TYPE_DELETE_FAIL = "FOOD_MENU_TYPE_DELETE_FAIL";

///foodpreordereventtype/list
export const FOOD_PREORDER_EVENT_TYPE_LIST = "FOOD_PREORDER_EVENT_TYPE_LIST";
export const FOOD_PREORDER_EVENT_TYPE_LIST_SUCCESS =
  "FOOD_PREORDER_EVENT_TYPE_LIST_SUCCESS";
export const FOOD_PREORDER_EVENT_TYPE_LIST_FAIL =
  "FOOD_PREORDER_EVENT_TYPE_LIST_FAIL";

///foodpreordereventtype/data
export const FOOD_PREORDER_EVENT_TYPE_DATA = "FOOD_PREORDER_EVENT_TYPE_DATA";
export const FOOD_PREORDER_EVENT_TYPE_DATA_SUCCESS =
  "FOOD_PREORDER_EVENT_TYPE_DATA_SUCCESS";
export const FOOD_PREORDER_EVENT_TYPE_DATA_FAIL =
  "FOOD_PREORDER_EVENT_TYPE_DATA_FAIL";

///foodpreordereventtype/create
export const FOOD_PREORDER_EVENT_TYPE_CREATE =
  "FOOD_PREORDER_EVENT_TYPE_CREATE";
export const FOOD_PREORDER_EVENT_TYPE_CREATE_SUCCESS =
  "FOOD_PREORDER_EVENT_TYPE_CREATE_SUCCESS";
export const FOOD_PREORDER_EVENT_TYPE_CREATE_FAIL =
  "FOOD_PREORDER_EVENT_TYPE_CREATE_FAIL";

///foodpreordereventtype/update
export const FOOD_PREORDER_EVENT_TYPE_UPDATE =
  "FOOD_PREORDER_EVENT_TYPE_UPDATE";
export const FOOD_PREORDER_EVENT_TYPE_UPDATE_SUCCESS =
  "FOOD_PREORDER_EVENT_TYPE_UPDATE_SUCCESS";
export const FOOD_PREORDER_EVENT_TYPE_UPDATE_FAIL =
  "FOOD_PREORDER_EVENT_TYPE_UPDATE_FAIL";

///foodpreordereventtype/delete
export const FOOD_PREORDER_EVENT_TYPE_DELETE =
  "FOOD_PREORDER_EVENT_TYPE_DELETE";
export const FOOD_PREORDER_EVENT_TYPE_DELETE_SUCCESS =
  "FOOD_PREORDER_EVENT_TYPE_DELETE_SUCCESS";
export const FOOD_PREORDER_EVENT_TYPE_DELETE_FAIL =
  "FOOD_PREORDER_EVENT_TYPE_DELETE_FAIL";

///foodpreordersitelocation/list
export const FOOD_PREORDER_SITE_LOCATION_LIST =
  "FOOD_PREORDER_SITE_LOCATION_LIST";
export const FOOD_PREORDER_SITE_LOCATION_LIST_SUCCESS =
  "FOOD_PREORDER_SITE_LOCATION_LIST_SUCCESS";
export const FOOD_PREORDER_SITE_LOCATION_LIST_FAIL =
  "FOOD_PREORDER_SITE_LOCATION_LIST_FAIL";

///foodpreordersitelocation/data
export const FOOD_PREORDER_SITE_LOCATION_DATA =
  "FOOD_PREORDER_SITE_LOCATION_DATA";
export const FOOD_PREORDER_SITE_LOCATION_DATA_SUCCESS =
  "FOOD_PREORDER_SITE_LOCATION_DATA_SUCCESS";
export const FOOD_PREORDER_SITE_LOCATION_DATA_FAIL =
  "FOOD_PREORDER_SITE_LOCATION_DATA_FAIL";

///foodpreordersitelocation/create
export const FOOD_PREORDER_SITE_LOCATION_CREATE =
  "FOOD_PREORDER_SITE_LOCATION_CREATE";
export const FOOD_PREORDER_SITE_LOCATION_CREATE_SUCCESS =
  "FOOD_PREORDER_SITE_LOCATION_CREATE_SUCCESS";
export const FOOD_PREORDER_SITE_LOCATION_CREATE_FAIL =
  "FOOD_PREORDER_SITE_LOCATION_CREATE_FAIL";

///foodpreordersitelocation/update
export const FOOD_PREORDER_SITE_LOCATION_UPDATE =
  "FOOD_PREORDER_SITE_LOCATION_UPDATE";
export const FOOD_PREORDER_SITE_LOCATION_UPDATE_SUCCESS =
  "FOOD_PREORDER_SITE_LOCATION_UPDATE_SUCCESS";
export const FOOD_PREORDER_SITE_LOCATION_UPDATE_FAIL =
  "FOOD_PREORDER_SITE_LOCATION_UPDATE_FAIL";

///foodpreordersitelocation/delete
export const FOOD_PREORDER_SITE_LOCATION_DELETE =
  "FOOD_PREORDER_SITE_LOCATION_DELETE";
export const FOOD_PREORDER_SITE_LOCATION_DELETE_SUCCESS =
  "FOOD_PREORDER_SITE_LOCATION_DELETE_SUCCESS";
export const FOOD_PREORDER_SITE_LOCATION_DELETE_FAIL =
  "FOOD_PREORDER_SITE_LOCATION_DELETE_FAIL";

///foodmenucategory/list
export const FOOD_MENU_CATEGORY_LIST = "FOOD_MENU_CATEGORY_LIST";
export const FOOD_MENU_CATEGORY_LIST_SUCCESS =
  "FOOD_MENU_CATEGORY_LIST_SUCCESS";
export const FOOD_MENU_CATEGORY_LIST_FAIL = "FOOD_MENU_CATEGORY_LIST_FAIL";

///foodmenucategory/data
export const FOOD_MENU_CATEGORY_DATA = "FOOD_MENU_CATEGORY_DATA";
export const FOOD_MENU_CATEGORY_DATA_SUCCESS =
  "FOOD_MENU_CATEGORY_DATA_SUCCESS";
export const FOOD_MENU_CATEGORY_DATA_FAIL = "FOOD_MENU_CATEGORY_DATA_FAIL";

///foodmenucategory/create
export const FOOD_MENU_CATEGORY_CREATE = "FOOD_MENU_CATEGORY_CREATE";
export const FOOD_MENU_CATEGORY_CREATE_SUCCESS =
  "FOOD_MENU_CATEGORY_CREATE_SUCCESS";
export const FOOD_MENU_CATEGORY_CREATE_FAIL = "FOOD_MENU_CATEGORY_CREATE_FAIL";

///foodmenucategory/update
export const FOOD_MENU_CATEGORY_UPDATE = "FOOD_MENU_CATEGORY_UPDATE";
export const FOOD_MENU_CATEGORY_UPDATE_SUCCESS =
  "FOOD_MENU_CATEGORY_UPDATE_SUCCESS";
export const FOOD_MENU_CATEGORY_UPDATE_FAIL = "FOOD_MENU_CATEGORY_UPDATE_FAIL";

///foodmenucategory/delete
export const FOOD_MENU_CATEGORY_DELETE = "FOOD_MENU_CATEGORY_DELETE";
export const FOOD_MENU_CATEGORY_DELETE_SUCCESS =
  "FOOD_MENU_CATEGORY_DELETE_SUCCESS";
export const FOOD_MENU_CATEGORY_DELETE_FAIL = "FOOD_MENU_CATEGORY_DELETE_FAIL";

//foodpreordereventguesttofoodmenuitem/create
export const FOOD_PREORDER_EVENT_GUEST_TO_FOOD_MENU_ITEM_CREATE =
  "FOOD_PREORDER_EVENT_GUEST_TO_FOOD_MENU_ITEM_CREATE";
export const FOOD_PREORDER_EVENT_GUEST_TO_FOOD_MENU_ITEM_CREATE_SUCCESS =
  "FOOD_PREORDER_EVENT_GUEST_TO_FOOD_MENU_ITEM_CREATE_SUCCESS";
export const FOOD_PREORDER_EVENT_GUEST_TO_FOOD_MENU_ITEM_CREATE_FAIL =
  "FOOD_PREORDER_EVENT_GUEST_TO_FOOD_MENU_ITEM_CREATE_FAIL";

///foodpreordereventguest/accept
export const FOOD_PREORDER_EVENT_GUEST_ACCEPT =
  "FOOD_PREORDER_EVENT_GUEST_ACCEPT";
export const FOOD_PREORDER_EVENT_GUEST_ACCEPT_SUCCESS =
  "FOOD_PREORDER_EVENT_GUEST_ACCEPT_SUCCESS";
export const FOOD_PREORDER_EVENT_GUEST_ACCEPT_FAIL =
  "FOOD_PREORDER_EVENT_GUEST_ACCEPT_FAIL";
///foodpreordereventguest/decline
export const FOOD_PREORDER_EVENT_GUEST_DECLINE =
  "FOOD_PREORDER_EVENT_GUEST_DECLINE";
export const FOOD_PREORDER_EVENT_GUEST_DECLINE_SUCCESS =
  "FOOD_PREORDER_EVENT_GUEST_DECLINE_SUCCESS";
export const FOOD_PREORDER_EVENT_GUEST_DECLINE_FAIL =
  "FOOD_PREORDER_EVENT_GUEST_DECLINE_FAIL";

//foodmenu/search
export const FOOD_MENU_SEARCH = "FOOD_MENU_SEARCH";
export const FOOD_MENU_SEARCH_SUCCESS = "FOOD_MENU_SEARCH_SUCCESS";
export const FOOD_MENU_SEARCH_FAIL = "FOOD_MENU_SEARCH_FAIL";

///foodpreorderevent/email/organiser/eventready
export const FOOD_PREORDER_EVENT_EMAIL_ORGANISER_EVENT_READY =
  "FOOD_PREORDER_EVENT_EMAIL_ORGANISER_EVENT_READY";
export const FOOD_PREORDER_EVENT_EMAIL_ORGANISER_EVENT_READY_SUCCESS =
  "FOOD_PREORDER_EVENT_EMAIL_ORGANISER_EVENT_READY_SUCCESS";
export const FOOD_PREORDER_EVENT_EMAIL_ORGANISER_EVENT_READY_FAIL =
  "FOOD_PREORDER_EVENT_EMAIL_ORGANISER_EVENT_READY_FAIL";

///foodpreordereventguest/invite/resend
export const FOOD_PREORDER_EVENT_GUEST_INVITE_RESEND =
  "FOOD_PREORDER_EVENT_GUEST_INVITE_RESEND";
export const FOOD_PREORDER_EVENT_GUEST_INVITE_RESEND_SUCCESS =
  "FOOD_PREORDER_EVENT_GUEST_INVITE_RESEND_SUCCESS";
export const FOOD_PREORDER_EVENT_GUEST_INVITE_RESEND_FAIL =
  "FOOD_PREORDER_EVENT_GUEST_INVITE_RESEND_FAIL";

///foodpreorderevent/pdf/guestlist/confirmed/
export const FOOD_PREORDER_EVENT_PDF_GUEST_LIST_CONFIRMED =
  "FOOD_PREORDER_EVENT_PDF_GUEST_LIST_CONFIRMED";
export const FOOD_PREORDER_EVENT_PDF_GUEST_LIST_CONFIRMED_SUCCESS =
  "FOOD_PREORDER_EVENT_PDF_GUEST_LIST_CONFIRMED_SUCCESS";
export const FOOD_PREORDER_EVENT_PDF_GUEST_LIST_CONFIRMED_FAIL =
  "FOOD_PREORDER_EVENT_PDF_GUEST_LIST_CONFIRMED_FAIL";

///foodpreorderevent/pdf/kitchenmealplan/
export const FOOD_PREORDER_EVENT_PDF_KITCHEN_MEAL_PLAN =
  "FOOD_PREORDER_EVENT_PDF_KITCHEN_MEAL_PLAN";
export const FOOD_PREORDER_EVENT_PDF_KITCHEN_MEAL_PLAN_SUCCESS =
  "FOOD_PREORDER_EVENT_PDF_KITCHEN_MEAL_PLAN_SUCCESS";
export const FOOD_PREORDER_EVENT_PDF_KITCHEN_MEAL_PLAN_FAIL =
  "FOOD_PREORDER_EVENT_PDF_KITCHEN_MEAL_PLAN_FAIL";

///foodpreorderevent/pdf/tabletentcards
export const FOOD_PREORDER_EVENT_PDF_TABLE_TENT_CARDS =
  "FOOD_PREORDER_EVENT_PDF_TABLE_TENT_CARDS";
export const FOOD_PREORDER_EVENT_PDF_TABLE_TENT_CARDS_SUCCESS =
  "FOOD_PREORDER_EVENT_PDF_TABLE_TENT_CARDS_SUCCESS";
export const FOOD_PREORDER_EVENT_PDF_TABLE_TENT_CARDS_FAIL =
  "FOOD_PREORDER_EVENT_PDF_TABLE_TENT_CARDS_FAIL";

///foodpreordereventrecentactivity/list
export const FOOD_PREORDER_EVENT_RECENT_ACTIVITY_LIST =
  "FOOD_PREORDER_EVENT_RECENT_ACTIVITY_LIST";
export const FOOD_PREORDER_EVENT_RECENT_ACTIVITY_LIST_SUCCESS =
  "FOOD_PREORDER_EVENT_RECENT_ACTIVITY_LIST_SUCCESS";
export const FOOD_PREORDER_EVENT_RECENT_ACTIVITY_LIST_FAIL =
  "FOOD_PREORDER_EVENT_RECENT_ACTIVITY_LIST_FAIL";
///foodpreordereventcommunication/list
export const FOOD_PREORDER_EVENT_COMMUNICATION_LIST =
  "FOOD_PREORDER_EVENT_COMMUNICATION_LIST";
export const FOOD_PREORDER_EVENT_COMMUNICATION_LIST_SUCCESS =
  "FOOD_PREORDER_EVENT_COMMUNICATION_LIST_SUCCESS";
export const FOOD_PREORDER_EVENT_COMMUNICATION_LIST_FAIL =
  "FOOD_PREORDER_EVENT_COMMUNICATION_LIST_FAIL";
///foodpreordereventattachment/search
export const FOOD_PREORDER_EVENT_ATTACHMENT_SEARCH =
  "FOOD_PREORDER_EVENT_ATTACHMENT_SEARCH";
export const FOOD_PREORDER_EVENT_ATTACHMENT_SEARCH_SUCCESS =
  "FOOD_PREORDER_EVENT_ATTACHMENT_SEARCH_SUCCESS";
export const FOOD_PREORDER_EVENT_ATTACHMENT_SEARCH_FAIL =
  "FOOD_PREORDER_EVENT_ATTACHMENT_SEARCH_FAIL";
///foodpreordereventattachment/delete
export const FOOD_PREORDER_EVENT_ATTACHMENT_DELETE =
  "FOOD_PREORDER_EVENT_ATTACHMENT_DELETE";
export const FOOD_PREORDER_EVENT_ATTACHMENT_DELETE_SUCCESS =
  "FOOD_PREORDER_EVENT_ATTACHMENT_DELETE_SUCCESS";
export const FOOD_PREORDER_EVENT_ATTACHMENT_DELETE_FAIL =
  "FOOD_PREORDER_EVENT_ATTACHMENT_DELETE_FAIL";
///foodpreorderevent/sms/organiser/eventready/
export const FOOD_PREORDER_EVENT_SMS_ORGANISER_EVENT_READY =
  "FOOD_PREORDER_EVENT_SMS_ORGANISER_EVENT_READY";
export const FOOD_PREORDER_EVENT_SMS_ORGANISER_EVENT_READY_SUCCESS =
  "FOOD_PREORDER_EVENT_SMS_ORGANISER_EVENT_READY_SUCCESS";
export const FOOD_PREORDER_EVENT_SMS_ORGANISER_EVENT_READY_FAIL =
  "FOOD_PREORDER_EVENT_SMS_ORGANISER_EVENT_READY_FAIL";
///foodmenu/search
export const FOOD_MENU_ITEM_SEARCH = "FOOD_MENU_ITEM_SEARCH";
export const FOOD_MENU_ITEM_SEARCH_SUCCESS = "FOOD_MENU_ITEM_SEARCH_SUCCESS";
export const FOOD_MENU_ITEM_SEARCH_FAIL = "FOOD_MENU_ITEM_SEARCH_FAIL";

//Food front of house meal plan
///foodpreorderevent/pdf/frontofhousemealplan/
export const FOOD_PREORDER_EVENT_PDF_FRONT_OF_HOUSE_MEAL_PLAN =
  "FOOD_PREORDER_EVENT_PDF_FRONT_OF_HOUSE_MEAL_PLAN";
export const FOOD_PREORDER_EVENT_PDF_FRONT_OF_HOUSE_MEAL_PLAN_SUCCESS =
  "FOOD_PREORDER_EVENT_PDF_FRONT_OF_HOUSE_MEAL_PLAN_SUCCESS";
export const FOOD_PREORDER_EVENT_PDF_FRONT_OF_HOUSE_MEAL_PLAN_FAIL =
  "FOOD_PREORDER_EVENT_PDF_FRONT_OF_HOUSE_MEAL_PLAN_FAIL";

///foodpreordereventguestpayment/list
export const FOOD_PREORDER_EVENT_GUEST_PAYMENT_LIST =
  "FOOD_PREORDER_EVENT_GUEST_PAYMENT_LIST";
export const FOOD_PREORDER_EVENT_GUEST_PAYMENT_LIST_SUCCESS =
  "FOOD_PREORDER_EVENT_GUEST_PAYMENT_LIST_SUCCESS";
export const FOOD_PREORDER_EVENT_GUEST_PAYMENT_LIST_FAIL =
  "FOOD_PREORDER_EVENT_GUEST_PAYMENT_LIST_FAIL";

///foodpreordereventguestpayment/search
export const FOOD_PREORDER_EVENT_GUEST_PAYMENT_SEARCH =
  "FOOD_PREORDER_EVENT_GUEST_PAYMENT_SEARCH";
export const FOOD_PREORDER_EVENT_GUEST_PAYMENT_SEARCH_SUCCESS =
  "FOOD_PREORDER_EVENT_GUEST_PAYMENT_SEARCH_SUCCESS";
export const FOOD_PREORDER_EVENT_GUEST_PAYMENT_SEARCH_FAIL =
  "FOOD_PREORDER_EVENT_GUEST_PAYMENT_SEARCH_FAIL";

///foodpreordereventgroup/list
export const FOOD_PREORDER_EVENT_GROUP_LIST = "FOOD_PREORDER_EVENT_GROUP_LIST";
export const FOOD_PREORDER_EVENT_GROUP_LIST_SUCCESS =
  "FOOD_PREORDER_EVENT_GROUP_LIST_SUCCESS";
export const FOOD_PREORDER_EVENT_GROUP_LIST_FAIL =
  "FOOD_PREORDER_EVENT_GROUP_LIST_FAIL";

///foodpreordereventgroup/data
export const FOOD_PREORDER_EVENT_GROUP_DATA = "FOOD_PREORDER_EVENT_GROUP_DATA";
export const FOOD_PREORDER_EVENT_GROUP_DATA_SUCCESS =
  "FOOD_PREORDER_EVENT_GROUP_DATA_SUCCESS";
export const FOOD_PREORDER_EVENT_GROUP_DATA_FAIL =
  "FOOD_PREORDER_EVENT_GROUP_DATA_FAIL";

///foodpreordereventgroup/create
export const FOOD_PREORDER_EVENT_GROUP_CREATE =
  "FOOD_PREORDER_EVENT_GROUP_CREATE";
export const FOOD_PREORDER_EVENT_GROUP_CREATE_SUCCESS =
  "FOOD_PREORDER_EVENT_GROUP_CREATE_SUCCESS";
export const FOOD_PREORDER_EVENT_GROUP_CREATE_FAIL =
  "FOOD_PREORDER_EVENT_GROUP_CREATE_FAIL";

///foodpreordereventgroup/update
export const FOOD_PREORDER_EVENT_GROUP_UPDATE =
  "FOOD_PREORDER_EVENT_GROUP_UPDATE";
export const FOOD_PREORDER_EVENT_GROUP_UPDATE_SUCCESS =
  "FOOD_PREORDER_EVENT_GROUP_UPDATE_SUCCESS";
export const FOOD_PREORDER_EVENT_GROUP_UPDATE_FAIL =
  "FOOD_PREORDER_EVENT_GROUP_UPDATE_FAIL";

///foodpreordereventgroup/delete
export const FOOD_PREORDER_EVENT_GROUP_DELETE =
  "FOOD_PREORDER_EVENT_GROUP_DELETE";
export const FOOD_PREORDER_EVENT_GROUP_DELETE_SUCCESS =
  "FOOD_PREORDER_EVENT_GROUP_DELETE_SUCCESS";
export const FOOD_PREORDER_EVENT_GROUP_DELETE_FAIL =
  "FOOD_PREORDER_EVENT_GROUP_DELETE_FAIL";

///foodpreordereventrecentactivity/list /data
export const FOOD_PREORDER_EVENT_RECENT_ACTIVITY_LIST_DATA =
  "FOOD_PREORDER_EVENT_RECENT_ACTIVITY_LIST_DATA";
export const FOOD_PREORDER_EVENT_RECENT_ACTIVITY_LIST_DATA_SUCCESS =
  "FOOD_PREORDER_EVENT_RECENT_ACTIVITY_LIST_DATA_SUCCESS";
export const FOOD_PREORDER_EVENT_RECENT_ACTIVITY_LIST_DATA_FAIL =
  "FOOD_PREORDER_EVENT_RECENT_ACTIVITY_LIST_DATA_FAIL";

///foodpreordereventgroup/pdf/kitchenmealplan/
export const FOOD_PREORDER_EVENT_GROUP_PDF_KITCHEN_MEAL_PLAN =
  "FOOD_PREORDER_EVENT_GROUP_PDF_KITCHEN_MEAL_PLAN";
export const FOOD_PREORDER_EVENT_GROUP_PDF_KITCHEN_MEAL_PLAN_SUCCESS =
  "FOOD_PREORDER_EVENT_GROUP_PDF_KITCHEN_MEAL_PLAN_SUCCESS";
export const FOOD_PREORDER_EVENT_GROUP_PDF_KITCHEN_MEAL_PLAN_FAIL =
  "FOOD_PREORDER_EVENT_GROUP_PDF_KITCHEN_MEAL_PLAN_FAIL";

///foodpreordereventgroup/pdf/frontofhousemealplan/
export const FOOD_PREORDER_EVENT_GROUP_PDF_FRONT_OF_HOUSE_MEAL_PLAN =
  "FOOD_PREORDER_EVENT_GROUP_PDF_FRONT_OF_HOUSE_MEAL_PLAN";
export const FOOD_PREORDER_EVENT_GROUP_PDF_FRONT_OF_HOUSE_MEAL_PLAN_SUCCESS =
  "FOOD_PREORDER_EVENT_GROUP_PDF_FRONT_OF_HOUSE_MEAL_PLAN_SUCCESS";
export const FOOD_PREORDER_EVENT_GROUP_PDF_FRONT_OF_HOUSE_MEAL_PLAN_FAIL =
  "FOOD_PREORDER_EVENT_GROUP_PDF_FRONT_OF_HOUSE_MEAL_PLAN_FAIL";

///foodpreordereventgroup/pdf/tabletentcards
export const FOOD_PREORDER_EVENT_GROUP_PDF_TABLE_TENT_CARDS =
  "FOOD_PREORDER_EVENT_GROUP_PDF_TABLE_TENT_CARDS";
export const FOOD_PREORDER_EVENT_GROUP_PDF_TABLE_TENT_CARDS_SUCCESS =
  "FOOD_PREORDER_EVENT_GROUP_PDF_TABLE_TENT_CARDS_SUCCESS";
export const FOOD_PREORDER_EVENT_GROUP_PDF_TABLE_TENT_CARDS_FAIL =
  "FOOD_PREORDER_EVENT_GROUP_PDF_TABLE_TENT_CARDS_FAIL";

///foodpreordereventgroup/pdf/guestlist/confirmed/
export const FOOD_PREORDER_EVENT_GROUP_PDF_GUEST_LIST_CONFIRMED =
  "FOOD_PREORDER_EVENT_GROUP_PDF_GUEST_LIST_CONFIRMED";
export const FOOD_PREORDER_EVENT_GROUP_PDF_GUEST_LIST_CONFIRMED_SUCCESS =
  "FOOD_PREORDER_EVENT_GROUP_PDF_GUEST_LIST_CONFIRMED_SUCCESS";
export const FOOD_PREORDER_EVENT_GROUP_PDF_GUEST_LIST_CONFIRMED_FAIL =
  "FOOD_PREORDER_EVENT_GROUP_PDF_GUEST_LIST_CONFIRMED_FAIL";

///foodpreordereventgroup/pdf/tableplan/list/
export const FOOD_PREORDER_EVENT_GROUP_PDF_TABLE_PLAN_LIST =
  "FOOD_PREORDER_EVENT_GROUP_PDF_TABLE_PLAN_LIST";
export const FOOD_PREORDER_EVENT_GROUP_PDF_TABLE_PLAN_LIST_SUCCESS =
  "FOOD_PREORDER_EVENT_GROUP_PDF_TABLE_PLAN_LIST_SUCCESS";
export const FOOD_PREORDER_EVENT_GROUP_PDF_TABLE_PLAN_LIST_FAIL =
  "FOOD_PREORDER_EVENT_GROUP_PDF_TABLE_PLAN_LIST_FAIL";

///foodpreordereventgroup/csv/kitchenmealplan/
export const FOOD_PREORDER_EVENT_GROUP_CSV_KITCHEN_MEAL_PLAN =
  "FOOD_PREORDER_EVENT_GROUP_CSV_KITCHEN_MEAL_PLAN";
export const FOOD_PREORDER_EVENT_GROUP_CSV_KITCHEN_MEAL_PLAN_SUCCESS =
  "FOOD_PREORDER_EVENT_GROUP_CSV_KITCHEN_MEAL_PLAN_SUCCESS";
export const FOOD_PREORDER_EVENT_GROUP_CSV_KITCHEN_MEAL_PLAN_FAIL =
  "FOOD_PREORDER_EVENT_GROUP_CSV_KITCHEN_MEAL_PLAN_FAIL";

///foodpreordereventgroup/csv/frontofhousemealplan/
export const FOOD_PREORDER_EVENT_GROUP_CSV_FRONT_OF_HOUSE_MEAL_PLAN =
  "FOOD_PREORDER_EVENT_GROUP_CSV_FRONT_OF_HOUSE_MEAL_PLAN";
export const FOOD_PREORDER_EVENT_GROUP_CSV_FRONT_OF_HOUSE_MEAL_PLAN_SUCCESS =
  "FOOD_PREORDER_EVENT_GROUP_CSV_FRONT_OF_HOUSE_MEAL_PLAN_SUCCESS";
export const FOOD_PREORDER_EVENT_GROUP_CSV_FRONT_OF_HOUSE_MEAL_PLAN_FAIL =
  "FOOD_PREORDER_EVENT_GROUP_CSV_FRONT_OF_HOUSE_MEAL_PLAN_FAIL";

///foodpreordereventgroup/csv/guestlist/confirmed/
export const FOOD_PREORDER_EVENT_GROUP_CSV_GUEST_LIST_CONFIRMED =
  "FOOD_PREORDER_EVENT_GROUP_CSV_GUEST_LIST_CONFIRMED";
export const FOOD_PREORDER_EVENT_GROUP_CSV_GUEST_LIST_CONFIRMED_SUCCESS =
  "FOOD_PREORDER_EVENT_GROUP_CSV_GUEST_LIST_CONFIRMED_SUCCESS";
export const FOOD_PREORDER_EVENT_GROUP_CSV_GUEST_LIST_CONFIRMED_FAIL =
  "FOOD_PREORDER_EVENT_GROUP_CSV_GUEST_LIST_CONFIRMED_FAIL";

///foodpreordereventgroup/csv/tableplan/list/
export const FOOD_PREORDER_EVENT_GROUP_CSV_TABLE_PLAN_LIST =
  "FOOD_PREORDER_EVENT_GROUP_CSV_TABLE_PLAN_LIST";
export const FOOD_PREORDER_EVENT_GROUP_CSV_TABLE_PLAN_LIST_SUCCESS =
  "FOOD_PREORDER_EVENT_GROUP_CSV_TABLE_PLAN_LIST_SUCCESS";
export const FOOD_PREORDER_EVENT_GROUP_CSV_TABLE_PLAN_LIST_FAIL =
  "FOOD_PREORDER_EVENT_GROUP_CSV_TABLE_PLAN_LIST_FAIL";

///foodpreorderevent/csv/kitchenmealplan/
export const FOOD_PREORDER_EVENT_CSV_KITCHEN_MEAL_PLAN =
  "FOOD_PREORDER_EVENT_CSV_KITCHEN_MEAL_PLAN";
export const FOOD_PREORDER_EVENT_CSV_KITCHEN_MEAL_PLAN_SUCCESS =
  "FOOD_PREORDER_EVENT_CSV_KITCHEN_MEAL_PLAN_SUCCESS";
export const FOOD_PREORDER_EVENT_CSV_KITCHEN_MEAL_PLAN_FAIL =
  "FOOD_PREORDER_EVENT_CSV_KITCHEN_MEAL_PLAN_FAIL";

///foodpreorderevent/csv/frontofhousemealplan/
export const FOOD_PREORDER_EVENT_CSV_FRONT_OF_HOUSE_MEAL_PLAN =
  "FOOD_PREORDER_EVENT_CSV_FRONT_OF_HOUSE_MEAL_PLAN";
export const FOOD_PREORDER_EVENT_CSV_FRONT_OF_HOUSE_MEAL_PLAN_SUCCESS =
  "FOOD_PREORDER_EVENT_CSV_FRONT_OF_HOUSE_MEAL_PLAN_SUCCESS";
export const FOOD_PREORDER_EVENT_CSV_FRONT_OF_HOUSE_MEAL_PLAN_FAIL =
  "FOOD_PREORDER_EVENT_CSV_FRONT_OF_HOUSE_MEAL_PLAN_FAIL";

///foodpreorderevent/csv/guestlist/confirmed/
export const FOOD_PREORDER_EVENT_CSV_GUEST_LIST_CONFIRMED =
  "FOOD_PREORDER_EVENT_CSV_GUEST_LIST_CONFIRMED";
export const FOOD_PREORDER_EVENT_CSV_GUEST_LIST_CONFIRMED_SUCCESS =
  "FOOD_PREORDER_EVENT_CSV_GUEST_LIST_CONFIRMED_SUCCESS";
export const FOOD_PREORDER_EVENT_CSV_GUEST_LIST_CONFIRMED_FAIL =
  "FOOD_PREORDER_EVENT_CSV_GUEST_LIST_CONFIRMED_FAIL";

///foodpreordereventgroup/csv/drinklistbytable/
export const FOOD_PREORDER_EVENT_GROUP_CSV_DRINK_LIST_BY_TABLE =
  "FOOD_PREORDER_EVENT_GROUP_CSV_DRINK_LIST_BY_TABLE";
export const FOOD_PREORDER_EVENT_GROUP_CSV_DRINK_LIST_BY_TABLE_SUCCESS =
  "FOOD_PREORDER_EVENT_GROUP_CSV_DRINK_LIST_BY_TABLE_SUCCESS";
export const FOOD_PREORDER_EVENT_GROUP_CSV_DRINK_LIST_BY_TABLE_FAIL =
  "FOOD_PREORDER_EVENT_GROUP_CSV_DRINK_LIST_BY_TABLE_FAIL";

///foodpreordereventgroup/pdf/drinklistbytable/
export const FOOD_PREORDER_EVENT_GROUP_PDF_DRINK_LIST_BY_TABLE =
  "FOOD_PREORDER_EVENT_GROUP_PDF_DRINK_LIST_BY_TABLE";
export const FOOD_PREORDER_EVENT_GROUP_PDF_DRINK_LIST_BY_TABLE_SUCCESS =
  "FOOD_PREORDER_EVENT_GROUP_PDF_DRINK_LIST_BY_TABLE_SUCCESS";
export const FOOD_PREORDER_EVENT_GROUP_PDF_DRINK_LIST_BY_TABLE_FAIL =
  "FOOD_PREORDER_EVENT_GROUP_PDF_DRINK_LIST_BY_TABLE_FAIL";
///foodpreordersitelocation/search
export const FOOD_PREORDER_SITE_LOCATION_SEARCH =
  "FOOD_PREORDER_SITE_LOCATION_SEARCH";
export const FOOD_PREORDER_SITE_LOCATION_SEARCH_SUCCESS =
  "FOOD_PREORDER_SITE_LOCATION_SEARCH_SUCCESS";
export const FOOD_PREORDER_SITE_LOCATION_SEARCH_FAIL =
  "FOOD_PREORDER_SITE_LOCATION_SEARCH_FAIL";

///foodmenu/clone
export const FOOD_MENU_CLONE = "FOOD_MENU_CLONE";
export const FOOD_MENU_CLONE_SUCCESS = "FOOD_MENU_CLONE_SUCCESS";
export const FOOD_MENU_CLONE_FAIL = "FOOD_MENU_CLONE_FAIL";
